var data = {
	"body": "<g fill=\"none\"><path d=\"M9 6a3 3 0 1 1-6 0a3 3 0 0 1 6 0z\" fill=\"currentColor\"/><path d=\"M17 6a3 3 0 1 1-6 0a3 3 0 0 1 6 0z\" fill=\"currentColor\"/><path d=\"M12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 0 0-1.5-4.33A5 5 0 0 1 19 16v1h-6.07z\" fill=\"currentColor\"/><path d=\"M6 11a5 5 0 0 1 5 5v1H1v-1a5 5 0 0 1 5-5z\" fill=\"currentColor\"/></g>",
	"width": 20,
	"height": 20
};
exports.__esModule = true;
exports.default = data;
